import { GenericSelectComponents as components } from '../../GenericSelectControl/GenericSelectControl';
import { withClassName } from '../helper';
export const LookupClearIndicator = withClassName(components.ClearIndicator, 'selectIcon', 'cancel');